import module from '../module';
import * as _ from 'lodash';
import moment from 'moment';
import Constants from '../../../utils/CommonConstants';
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";

export class GroupOrderService {
  static $inject = ['$http', 'cartonomyConfig', 'CheckoutService', 'CartService', '$window'];

  constructor(httpService, cartonomyConfig, checkoutService, cartService, $window) {

    this.PayForEveryone = false;
    this.EverySelfPays = true;

    this._httpService = httpService;
    this._checkoutService = checkoutService;
    this._cartService = cartService;
    this._urlBase = cartonomyConfig.ApiV2 + 'order';
    this._urlGroupBase = cartonomyConfig.ApiV2 + 'group'
    this._windowService = $window;
    //noinspection JSIgnoredPromiseFromCall
    this.initConfiguration();

    this._customCartNameSetting = {
      customCartNames: '0',
        cartName: ''
    }
  }

  async save(data) {
    let cartName = this._customCartNameSetting.customCartNames === '1' ? this._customCartNameSetting.cartName : '';
    const configuration = this.serialize();
    const cart = await this._cartService.getCart();
    configuration.cartName = cartName;
    await this._cartService.setCartDetails(configuration);
    cart.orderLimit = configuration.price;
    cart.orderLimitType = configuration.budgetType;
    cart.closeOn = configuration.deadlineTime;
    cart.comment = '';
    cart.cartName = cartName;

    if(data && data.storeId) {
      cart.retailerStoreId = data.storeId;
    }

    await this._cartService.setCartConfiguration(cart);

    if(this._customCartNameSetting.customCartNames === '1' && this._customCartNameSetting.cartName !== ''){
      communicationService.requestToParent(commandKeys.updateMyCartButtonText, {cartNameValue: this._customCartNameSetting.cartName});
    }
  }

  async sendInvites() {
    //in case of single invitation, maybe there is no invitee when create the order
    if (this._configuration.contactDetails && this._configuration.contactDetails.selectedEmails) {
      const emails = this._configuration.contactDetails.selectedEmails;
      await this._cartService.sendInvites(emails);
    }
  }

  saveToSessionStorage() {
    this._windowService.sessionStorage.setItem(Constants.SessionStorage.NEW_ORDER_CONFIGURATION, JSON.stringify(this._configuration));
  }

  hasSavedSession() {
    const configuration = this._windowService.sessionStorage.getItem(Constants.SessionStorage.NEW_ORDER_CONFIGURATION);
    return !!configuration;
  }

  loadFromSessionStorage() {
    const configuration = this._windowService.sessionStorage.getItem(Constants.SessionStorage.NEW_ORDER_CONFIGURATION);
    this._configuration = JSON.parse(configuration);
  }

  serialize() {
    let configuration = _.cloneDeep(this._configuration);

    return {
      deliveryMethod: configuration.delivery ? Constants.CartDetails.DeliveryMethods.DELIVERY : Constants.CartDetails.DeliveryMethods.PICKUP,
      paymentMethod: configuration.paymentMethod,
      price: configuration.groupPay ? 0 : configuration.singlePayOrder.budget,
      budgetType: configuration.singlePayOrder.budgetType,
      deliveryPhone: configuration.deliveryDetails.phone,
      deadlineTime: configuration.deliveryDetails.deadlineTime,
      deliveryDate: configuration.deliveryDetails.deliveryTime,
      deliveryTime: configuration.deliveryDetails.deliveryTime,
      customCartNameSetting: this._customCartNameSetting
    };
  }

  async getPaymentSystems() {
    return await this._checkoutService.getVendorMap();
  }

  getPaymentSystem() {
    return this._configuration.paymentSystem;
  }

  setPaymentSystem(system) {
    this._configuration.paymentSystem = system;
  }

  setAmountToPay(amount) {
    this._configuration.amountToPay = amount;
  }

  getAmountToPay() {
    return this._configuration.amountToPay;
  }

  setDeliveryMode(mode) {
    this._configuration.delivery = mode;
  }

  getDeliveryMode() {
    return this._configuration.delivery;
  }

  getDeliveryDetails() {
    return this._configuration.deliveryDetails;
  }

  setDeliveryDetails(details) {
    this._configuration.deliveryDetails = details;
  }

  getDeliveryAddress() {
    return this._configuration.deliveryAddress;
  }

  setDeliveryAddress(address) {
    this._configuration.deliveryAddress = address;
  }

  setPaymentMethod(method) {
    this._configuration.paymentMethod = method;
  }

  getSelectedDeliveryAddress() {
    return this._configuration.selectedDeliveryAddress;
  }

  setSelectedDeliveryAddress(selectedAddress) {
    this._configuration.selectedDeliveryAddress = selectedAddress;
  }

  getGroupPay() {
    return this._configuration.groupPay;
  }

  setGroupPay(groupPay) {
    this._configuration.groupPay = groupPay;
  }

  getSinglePayOrder() {
    return this._configuration.singlePayOrder;
  }

  setSinglePayOrder(singlePay) {
    this._configuration.singlePayOrder = singlePay;
  }

  getContactDetails() {
    return this._configuration.contactDetails;
  }

  setContactDetails(details) {
    this._configuration.contactDetails = details;
  }

  getVendorDetails() {
    return this._configuration.vendorDetails;
  }

  setVendorDetails(details) {
    this._configuration.vendorDetails = details;
  }

  async initConfiguration() {
    this._configuration = {
      groupPay: true,
      amountToPay: 0
    };
  }

  async loadConfiguration(configuration) {

    const cart = await this._cartService.getCart();

    this._configuration = {
      delivery: configuration.deliveryMethod === Constants.CartDetails.DeliveryMethods.DELIVERY,
      groupPay: configuration.paymentMethod !== Constants.CartDetails.PaymentMethods.SINGLE,
      deliveryDetails: {
        deliveryTime: configuration.deliveryTime,
        deliveryDate: configuration.deliveryTime,
        phone: configuration.deliveryPhone,
        entered: !!configuration.deliveryPhone,
        accepted: !!configuration.deliveryPhone
      }
    };

    if (configuration.deliveryDetails) {
      //configuration.deliveryDetails.deadlineTime = cart.closeOn;
      this.setDeliveryDetails(configuration.deliveryDetails);
    } else {
      this._configuration.deliveryDetails.deadlineTime = cart.closeOn ?
        _.isDate(cart.closeOn) ? cart.closeOn : moment.utc(cart.closeOn).toDate() :
        undefined;

      this._configuration.deliveryDetails.defineDeadline = !!this._configuration.deliveryDetails.deadlineTime;

      this._configuration.deliveryDetails.placeEntered = true;
    }

    if (configuration.deliveryAddress) {
      this._configuration.deliveryAddress = {
        city: configuration.deliveryAddress.city,
        state: configuration.deliveryAddress.state,
        street: configuration.deliveryAddress.street,
        zip: configuration.deliveryAddress.zip,
        aptSuite: configuration.deliveryAddress.aptSuite,
        entered: !!configuration.deliveryAddress.street
      };
    }

    if (configuration.singlePayOrder) {
      configuration.singlePayOrder.budget = cart.orderLimit;
      this.setSinglePayOrder(configuration.singlePayOrder);
    } else {
      if (!this._configuration.groupPay) {
        this._configuration.singlePayOrder = {
          budget: cart.orderLimit
        };
      }
    }

    if (configuration.contactDetails) {
      this.setContactDetails(configuration.contactDetails);
    }

  }

  async payNow(details) {
    const response = await this._httpService.post(this._urlBase + "payNow", details);
    return response.data;
  }

  setCustomCartName(customCartNames, cartName){
    this._customCartNameSetting.customCartNames = customCartNames;
    this._customCartNameSetting.cartName = cartName;
  }

    async deleteContact(contactUserId) {
        const response = await this._httpService.delete(`${this._urlGroupBase}/contact/delete/${contactUserId}`);
        return response.data;
    }
}

module.service('GroupOrder', GroupOrderService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/GroupOrderService.js